//
import WhProductModel from '@/models/Warehouse/WhProduct'

//
export default class WhProductToSearch extends WhProductModel {

    /**
     * { item_description }
     */
    static appends = ['branch_offices', 'stocks']

    /**
     * { item_description }
     */
    static includes = ['wh_item']
}
